import {Box,Switch,FormGroup,Tooltip,FormControlLabel} from '@mui/material';

const FieldSwitchJoin=({row,rowJoin,recordRules,fieldNameJoin,application,readOnly,userData})=>{
    const fieldName=rowJoin[fieldNameJoin].foreign_key;
    const fieldProp=row?.[fieldName];

    return (
        <Box sx={{flex:1,minWidth:0}}>
            <FormGroup style={{paddingLeft:'10px',}}>
                <Tooltip 
                    placement="top"
                    title={fieldProp?.ui_tooltip?application.getLocale(fieldProp?.ui_tooltip):''}
                    disableHoverListener={!fieldProp?.ui_tooltip}>
                    <FormControlLabel control={
                        <Switch 
                            id={fieldName}
                            name={fieldName}
                            checked={rowJoin[fieldNameJoin]?.value??false}
                            disabled/>
                        }
                        label={rowJoin?.[fieldNameJoin]?.ui_label_locale?application.getLocale(rowJoin?.[fieldNameJoin]?.ui_label_locale):fieldNameJoin}/>
                </Tooltip>
            </FormGroup>
        </Box>
    );
}

export default FieldSwitchJoin;
